import PoolFormPage from "@modules/career-form/pages/PoolFormPage"

export default PoolFormPage
